import {
    UPDATE_TABLE_SUCCESS,
    UPDATE_TABLE_REQUEST,
    UPDATE_TABLE_ERROR,
  } from "../actions/types";
  
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case UPDATE_TABLE_REQUEST:
        return {
          loading: true,
        };
      case UPDATE_TABLE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload: payload,
        };
      case UPDATE_TABLE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
      default:
        return state;
    }
  }
  